import { CLIP_FRAME_RATE, MAX_CLIP_SECONDS, MIN_CLIP_SECONDS } from '../constants';

// 单帧时长（秒）：所有时间统一吸附到帧网格，微调按 ±1 帧步进
export const FRAME_SECONDS = 1 / CLIP_FRAME_RATE;

// 时长界限比较用 epsilon，与后端 clip.ValidateClipRange 一致，
// 避免帧对齐时间相减的浮点误差把边界值误判为越界
const DURATION_EPSILON = 1e-9;

// 时间吸附到最近的帧边界并约束在 [0, duration]；上界取不超过 duration 的最后一个帧边界
export function clampTime(t: number, duration: number): number {
  const snapped = Math.round(t * CLIP_FRAME_RATE) / CLIP_FRAME_RATE;
  const maxT = Math.floor(duration * CLIP_FRAME_RATE) / CLIP_FRAME_RATE;
  return Math.min(Math.max(0, snapped), maxT);
}

// 帧对齐时间 → 1 起始的帧号（t=0 为第 1 帧）
export function timeToFrameNumber(t: number): number {
  return Math.round(t * CLIP_FRAME_RATE) + 1;
}

export type ClipDurationErrorKind = 'invalid' | 'tooShort' | 'tooLong';

export function clipDurationError(start: number, end: number): ClipDurationErrorKind | null {
  if (end <= start) return 'invalid';
  const d = end - start;
  if (d < MIN_CLIP_SECONDS - DURATION_EPSILON) return 'tooShort';
  if (d > MAX_CLIP_SECONDS + DURATION_EPSILON) return 'tooLong';
  return null;
}

export function formatSeconds(t: number): string {
  return `${t.toFixed(2)}s`;
}

// 时间轴轨道坐标→时间（帧精度，钳制在 [0, duration]）
export function trackTimeFromClientX(clientX: number, rectLeft: number, rectWidth: number, duration: number): number {
  if (rectWidth <= 0 || duration <= 0) return 0;
  const ratio = (clientX - rectLeft) / rectWidth;
  return clampTime(ratio * duration, duration);
}
